"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFossilFree = function IconFossilFree(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36.728 36.728c6.792-6.792 7.021-17.662.688-24.73l-6.958 6.958c.503.915.782 2.003.782 3.194 0 3.474-2.376 6.066-5.724 6.066-1.262 0-2.385-.373-3.293-1.025L11.999 37.416c7.067 6.333 17.937 6.104 24.729-.688M29.386 22.15c0-.656-.108-1.268-.31-1.812l-5.57 5.57c.567.36 1.246.562 2.01.562 2.304 0 3.87-1.854 3.87-4.32m-3.87-6.066c1.444 0 2.707.482 3.677 1.31l6.809-6.81c-7.068-6.333-17.938-6.104-24.73.688s-7.021 17.662-.688 24.73l10.259-10.259c-.648-.99-1.015-2.223-1.015-3.593 0-3.492 2.34-6.066 5.688-6.066m-3.336 8.322 5.74-5.74c-.638-.53-1.456-.836-2.404-.836-2.322 0-3.834 1.836-3.834 4.32 0 .842.176 1.61.498 2.256m15.962 13.736c7.81-7.81 7.81-20.474 0-28.284s-20.474-7.81-28.284 0-7.81 20.474 0 28.284 20.474 7.81 28.284 0m-23.59-22.058c-3.33 0-5.724 2.628-5.724 6.066s2.394 6.066 5.724 6.066c1.602 0 3.078-.558 4.086-1.476l-.918-1.584a4.46 4.46 0 0 1-3.15 1.296c-2.196 0-3.888-1.746-3.888-4.302s1.692-4.302 3.888-4.302c1.278 0 2.358.522 3.15 1.296l.918-1.584c-1.008-.918-2.484-1.476-4.086-1.476m19.196 11.728c-1.164.624-2.292 1.392-2.292 3.468V32h5.352v-1.392h-3.636c0-.78.588-1.2 1.464-1.644l.348-.192c1.176-.588 1.92-1.368 1.92-2.496 0-1.332-1.044-2.22-2.604-2.22-1.056 0-2.124.432-2.808 1.032l.732 1.296c.564-.504 1.308-.924 2.04-.924.672 0 1.092.348 1.092.888 0 .492-.336.792-1.272 1.284z",
    clipRule: "evenodd"
  })));
};

export { IconFossilFree, IconFossilFree as default };
